import "./CountryFlagSelectComp.css";
import { defineComponent as c, resolveComponent as d, openBlock as p, createBlock as m, normalizeClass as n, withCtx as r, createElementVNode as l, toDisplayString as a } from "vue";
import { SelectItemComp as y } from "./SelectItemComp.js";
import { _ } from "./_plugin-vue_export-helper.dad06003.js";
const g = c({
  events: {
    "update:modelValue": {
      type: Object
    }
  },
  components: {
    SelectItemComp: y
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: Object,
      default: null
    },
    displayFunction: {
      type: Function,
      default: (e) => e
    },
    sortFunction: {
      type: Function,
      default: (e, o) => e.name < o.name ? -1 : e.name > o.name ? 1 : 0
    },
    region: {
      type: String,
      default: ""
    },
    showRestricted: {
      type: Boolean,
      default: !0
    },
    disabled: Boolean
  },
  data() {
    return {
      countries: []
    };
  },
  computed: {
    selectedCountry: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    countryFlagSelectClasses() {
      return {
        countryFlagSelect: !0,
        "countryFlagSelect--disabled": this.disabled
      };
    }
  },
  async created() {
    this.countries = (await this.getCountries()).filter((e) => {
      const o = this.region ? e.region === this.region : !0, s = this.showRestricted ? !0 : !e.isRestricted;
      return o && s;
    }).map(this.displayFunction).sort(this.sortFunction).map((e) => ({
      text: e.name,
      value: e
    }));
  },
  methods: {
    itiFlagClasses(e) {
      var s;
      const o = {
        itiFlag: !0,
        "itiFlag--disabled": this.disabled
      };
      return (s = e == null ? void 0 : e.value.code) != null && s.toLowerCase() && (o[e == null ? void 0 : e.value.code.toLowerCase()] = !0), o;
    },
    async getCountries() {
      try {
        return await (await fetch("/i18n/countries.json", {
          headers: { "Content-Type": "application/json" }
        })).json();
      } catch {
        return [];
      }
    }
  }
});
const C = ["aria-label"], b = ["aria-label"], f = ["for"], h = { class: "itiFlag__code" };
function F(e, o, s, v, S, w) {
  var i;
  const u = d("select-item-comp");
  return p(), m(u, {
    id: e.id,
    class: n(e.countryFlagSelectClasses),
    modelValue: e.selectedCountry,
    "onUpdate:modelValue": o[0] || (o[0] = (t) => e.selectedCountry = t),
    options: e.countries,
    disableMessages: "",
    disabled: e.disabled,
    blank: "",
    buttonAriaLabel: (i = e.selectedCountry) == null ? void 0 : i.value.name
  }, {
    selectedOption: r(({ data: t }) => [
      l("div", {
        class: n(e.itiFlagClasses(t)),
        "aria-label": t == null ? void 0 : t.name
      }, null, 10, C)
    ]),
    option: r(({ data: t }) => [
      l("div", {
        class: n(["itiFlag", t.value.code.toLowerCase()]),
        "aria-label": t.value.name
      }, null, 10, b),
      l("label", {
        class: "itiFlag__label",
        for: `flag-id-${t.value.code}`
      }, a(t.value.name), 9, f),
      l("span", h, "+" + a(t.value.phoneCountryCode), 1)
    ]),
    _: 1
  }, 8, ["id", "class", "modelValue", "options", "disabled", "buttonAriaLabel"]);
}
const B = /* @__PURE__ */ _(g, [["render", F], ["__scopeId", "data-v-99f12b30"]]);
export {
  B as CountryFlagSelectComp
};
//# sourceMappingURL=CountryFlagSelectComp.js.map
